import React, { useRef, useState } from 'react'

import PropTypes from 'prop-types'
import { Box, IconButton, Tooltip, Typography } from '@material-ui/core'
import { Check as CheckIcon, X as XIcon } from 'react-feather'

import ColorPicker from '../ColorPicker'
import useStyles from './styles'

const ColumnAddForm = ({ columnCount, onAdd, onCancel }) => {
  const classes = useStyles()
  const nameRef = useRef(null)
  const [color, setColor] = useState(ColorPicker.defaultColors[0])
  const [textColor, setTextColor] = useState('#000000')

  const handleAdd = () => {
    const name = nameRef.current?.value?.trim()
    if (!name) return
    onAdd(name, color, textColor)
  }

  return (
    <Box className={classes.addRow}>
      <Box />
      <Typography className={classes.idCell}>#{columnCount + 1}</Typography>
      <input
        className={classes.nameInput}
        placeholder="Nome da coluna"
        ref={nameRef}
        autoFocus
      />
      <ColorPicker value={color} onChange={setColor} />
      <ColorPicker value={textColor} onChange={setTextColor} />
      <Box className={classes.actionsCell}>
        <Tooltip title="Adicionar">
          <IconButton
            size="small"
            className={classes.actionBtn}
            onClick={handleAdd}
          >
            <CheckIcon size={14} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Cancelar">
          <IconButton
            size="small"
            className={classes.actionBtn}
            onClick={onCancel}
          >
            <XIcon size={14} />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  )
}

ColumnAddForm.propTypes = {
  columnCount: PropTypes.number.isRequired,
  onAdd: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default ColumnAddForm
